import { hot } from 'react-hot-loader/root';
import React from 'react';
import { LDProvider } from 'launchdarkly-react-client-sdk';

import { MuiThemeProvider } from '@material-ui/core/styles';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './store';

import './styles/bootstrapCustomized.scss';
import './styles/app.css'; // eslint-disable-line

import routes from './routes';
import muiThemeV1 from './muiThemeV1';
import FloatingButton from './components/FloatingButton';
import ConnectedIntlProvider from './components/ConnectedIntlProvider';
import MuiPickersUtilsProviderLocalized from './components/MuiPickersUtilsProviderLocalized';

const clientSideID = process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID;

function App() {
    return (
        <LDProvider clientSideID={clientSideID}>
            <Provider store={store}>
                <MuiThemeProvider theme={muiThemeV1}>
                    <ConnectedIntlProvider>
                        <MuiPickersUtilsProviderLocalized>
                            <BrowserRouter>
                                {routes}
                                <FloatingButton />
                            </BrowserRouter>
                        </MuiPickersUtilsProviderLocalized>
                    </ConnectedIntlProvider>
                </MuiThemeProvider>
            </Provider>
        </LDProvider>
    );
}

export default hot(App);
